export default __webpack_public_path__ + "static/media/footer_cycle.4753aaf6.gif";